import React from 'react';
import { Box } from '@tanium/react-box';
import styled from '@tanium/react-emotion-9';
import { FormTextInput } from '@tanium/react-form-text-input';
import { Spinner } from '@tanium/react-spinner';
import { Stack } from '@tanium/react-stack';
import { css } from '@tanium/style-system';
import { Button } from '@tanium/react-button';

export const LoginFormTextInput = styled(FormTextInput)(
  css({
    width: '100%',
  })
);

interface LoginFormButtonProps {
  loading?: boolean;
  isDisabled?: boolean;
}
export const LoginFormButton: React.FC<LoginFormButtonProps> = ({ children, loading, isDisabled }) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    <Box width="100%">
      <Button style={{ width: '100%' }} type="submit" disabled={loading || isDisabled}>
        <Box as={Stack} justifyContent="center">
          {loading && (
            <Box mr={1}>
              <Spinner size={16} fill={false} />
            </Box>
          )}
          {children}
        </Box>
      </Button>
    </Box>
  );
};
